import { SyntheticEvent } from "react";

export type AnnouncementsCloseSource = "escape" | "x";

// The modal closes on Esc from a keydown, else on its X; a backdrop click does not close it.
const getAnnouncementsCloseSource = ({ type }: SyntheticEvent): AnnouncementsCloseSource =>
  type === "keydown" ? "escape" : "x";

export default getAnnouncementsCloseSource;
